export const heroHighlights = [
  {
    index: "01",
    title: "今日更新速递",
    desc: "零点起全网同步，按分钟刷新，打开就是今天最新的一批料。",
  },
  {
    index: "02",
    title: "最快黑料汇总",
    desc: "先落后核再补证，速度优先但标注可信度，追新不追谣。",
  },
  {
    index: "03",
    title: "实时追新提醒",
    desc: "把热度最高的三条推到你眼前，不用自己一条条翻。",
  },
];

export const liveFeed = [
  {
    time: "09:41",
    tag: "今日更新",
    title: "综艺常驻嘉宾深夜取关同组艺人，双方工作室暂无回应",
    summary:
      "凌晨两点被发现集中清空互动记录，粉丝整理出取关时间线，目前双方均未发声，爱黑料网持续同步后续。",
    heat: "9862",
    live: true,
  },
  {
    time: "09:12",
    tag: "最快黑料",
    title: "音乐节压轴阵容临时换人，官宣文案删改三次",
    summary:
      "主办方在原海报发布四十分钟后替换主视觉，新旧版本对比图已在站内汇总，换人原因仍待确认。",
    heat: "8410",
    live: true,
  },
  {
    time: "08:47",
    tag: "实时更新",
    title: "某剧组路透流出，男女主对手戏补拍两天",
    summary:
      "站内收录的通告单显示补拍集中在夜戏，接近剧组的知情人称与剧情调整有关，官方尚未定档。",
    heat: "7295",
    live: false,
  },
  {
    time: "08:05",
    tag: "今日新料",
    title: "品牌代言一夜换图，旧物料进入下架流程",
    summary:
      "多个电商页面的主图在清晨同步替换，合作期限与续约情况被反复讨论，我们已整理替换前后对照。",
    heat: "6702",
    live: false,
  },
  {
    time: "07:30",
    tag: "热点追踪",
    title: "旅行综艺同框照出现第三位神秘面孔",
    summary:
      "路透图中站在两人之间的身影引发猜测，站内按鞋型与行程做了比对，结论仍标注为待证。",
    heat: "6120",
    live: false,
  },
  {
    time: "06:58",
    tag: "最快黑料",
    title: "短剧爆款男女主被扒同款饰品，双方团队保持沉默",
    summary:
      "同款单品在四十八小时内两次出现，网友按时间点整理出「巧合清单」，本条可信度标注为中。",
    heat: "5588",
    live: false,
  },
  {
    time: "06:20",
    tag: "今日更新",
    title: "演唱会加场门票开售即清空，二手溢价被集中吐槽",
    summary:
      "站内收集了本轮开票的几张关键截图，加场场次与退票政策成为讨论重点，后续以官方口径为准。",
    heat: "5015",
    live: false,
  },
  {
    time: "05:44",
    tag: "深夜爆料",
    title: "匿名投稿称某组合合约到期，暂列待证清单",
    summary:
      "投稿未提供可核验材料，我们已将其放入待证池并标注来源可信度，核实后将更新本条状态。",
    heat: "4472",
    live: false,
  },
];

export const todayCards = [
  {
    id: "t1",
    tag: "今日头条",
    title: "开年最大争议：一档综艺的口碑为何三天翻面",
    excerpt:
      "从首播好评到集中差评，站内把舆论拐点按小时还原，剪辑、赛制与嘉宾配比是讨论最密集的三处。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20still%20life%20with%20folded%20newspaper%20stack%20and%20vintage%20camera%20on%20warm%20cream%20paper%20background%2C%20soft%20directional%20studio%20light%2C%20muted%20crimson%20and%20amber%20accents%2C%20minimal%20grain%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=600&seq=ahl-today-01&orientation=landscape",
    source: "站内编辑部",
    reads: "12.4万",
  },
  {
    id: "t2",
    tag: "最快黑料",
    title: "同款单品十四次撞车，时间线还原这次巧合",
    excerpt:
      "站内按发布顺序排出了完整对照表，哪些是可解释的商务合作，哪些仍属待证，我们分开标注。",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20small%20luxury%20accessory%20and%20watch%20laid%20on%20textured%20cream%20linen%2C%20warm%20editorial%20lighting%2C%20crimson%20ribbon%20accent%2C%20soft%20shadows%2C%20magazine%20product%20photography%2C%20muted%20palette%2C%20high%20detail&width=800&height=600&seq=ahl-today-02&orientation=landscape",
    source: "网友整理",
    reads: "9.7万",
  },
  {
    id: "t3",
    tag: "实时更新",
    title: "影视城连拍四十天，剧组日程表被完整拼出",
    excerpt:
      "由粉丝零散路透拼合而成的日程图，标注了夜戏与补拍节点，帮助追新用户判断下一次曝光窗口。",
    image:
      "https://readdy.ai/api/search-image?query=Film%20set%20monitor%20and%20clapperboard%20on%20warm%20beige%20desk%2C%20soft%20studio%20light%2C%20editorial%20magazine%20aesthetic%2C%20crimson%20and%20gold%20accents%2C%20subtle%20film%20grain%2C%20clean%20background%2C%20high%20detail&width=800&height=600&seq=ahl-today-03&orientation=landscape",
    source: "站内编辑部",
    reads: "8.1万",
  },
  {
    id: "t4",
    tag: "今日新料",
    title: "品牌换代言的七十二小时，物料替换全记录",
    excerpt:
      "站内抓取了各平台主图的替换时间，并把官宣前后的口径变化做成对照，方便快速理解这次调整。",
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20glossy%20magazine%20covers%20with%20abstract%20geometric%20art%2C%20warm%20cream%20and%20crimson%20tones%2C%20editorial%20studio%20lighting%2C%20soft%20paper%20texture%2C%20minimal%20composition%2C%20high%20detail&width=800&height=600&seq=ahl-today-04&orientation=landscape",
    source: "站内编辑部",
    reads: "7.3万",
  },
  {
    id: "t5",
    tag: "热点追踪",
    title: "一次机场同框，牵出三段互不相关的行程",
    excerpt:
      "按公开航班与活动日程交叉比对，站内还原了这次偶遇的全部可能路径，并标出证据强弱。",
    image:
      "https://readdy.ai/api/search-image?query=Window%20view%20of%20airport%20runway%20at%20golden%20hour%20through%20curved%20glass%2C%20warm%20amber%20and%20cream%20palette%2C%20editorial%20travel%20photography%2C%20soft%20light%2C%20abstract%20minimal%20composition%2C%20high%20detail&width=800&height=600&seq=ahl-today-05&orientation=landscape",
    source: "网友整理",
    reads: "6.6万",
  },
  {
    id: "t6",
    tag: "深夜爆料",
    title: "待证池本周更新：七条投稿三条已核实",
    excerpt:
      "我们坚持先标注可信度再传播，本周进入待证池的投稿里，已有三条完成交叉核实并更新状态。",
    image:
      "https://readdy.ai/api/search-image?query=Notebook%20with%20handwritten%20checklist%20and%20fountain%20pen%20on%20warm%20cream%20desk%2C%20soft%20window%20light%2C%20editorial%20documentary%20style%2C%20crimson%20and%20amber%20accents%2C%20muted%20palette%2C%20high%20detail&width=800&height=600&seq=ahl-today-06&orientation=landscape",
    source: "站内审核组",
    reads: "5.9万",
  },
];

export const hotRanking = [
  { rank: 1, title: "综艺常驻深夜取关事件时间线", heat: "9862", trend: "up" },
  { rank: 2, title: "音乐节压轴临时换人风波", heat: "8410", trend: "up" },
  { rank: 3, title: "剧组补拍两天通告单流出", heat: "7295", trend: "flat" },
  { rank: 4, title: "品牌代言一夜换图全记录", heat: "6702", trend: "up" },
  { rank: 5, title: "旅行综艺第三位神秘面孔", heat: "6120", trend: "down" },
  { rank: 6, title: "短剧男女主同款饰品对照", heat: "5588", trend: "flat" },
  { rank: 7, title: "演唱会加场门票秒空争议", heat: "5015", trend: "down" },
  { rank: 8, title: "匿名投稿组合合约到期待证", heat: "4472", trend: "up" },
];

export const topics = [
  { name: "今日更新", count: 128, icon: "ri-flashlight-line" },
  { name: "最快黑料", count: 96, icon: "ri-rocket-2-line" },
  { name: "实时快讯", count: 214, icon: "ri-radar-line" },
  { name: "热榜追新", count: 78, icon: "ri-fire-line" },
  { name: "待证清单", count: 43, icon: "ri-question-line" },
  { name: "综艺现场", count: 61, icon: "ri-movie-2-line" },
  { name: "音乐演出", count: 54, icon: "ri-mic-2-line" },
  { name: "影视路透", count: 87, icon: "ri-camera-lens-line" },
];

export const trustStats = [
  { value: "1,286", label: "今日更新条数", note: "零点至当下累计" },
  { value: "42", label: "平均更新间隔", note: "单位：分钟" },
  { value: "3 级", label: "可信度标注", note: "待证 / 待核 / 已核" },
];

export const trustPillars = [
  {
    icon: "ri-time-line",
    title: "更新更快，但先标可信度",
    desc: "每条料都会带上待证、待核或已核的标签，速度与谨慎同时给到你，追新不追谣。",
  },
  {
    icon: "ri-shield-check-line",
    title: "来源可回溯",
    desc: "站内编辑部、网友整理与匿名投稿分开标注来源，能核的核，不能核的老实说明白。",
  },
  {
    icon: "ri-refresh-line",
    title: "全天候同步",
    desc: "今日更新与实时快讯两条线并行，热点变化后我们会回来更新同一条，而不是只发新帖。",
  },
];

export const faqs = [
  {
    q: "爱黑料网的「今日更新」是什么时候刷新的？",
    a: "今日更新从每天零点开始累计，全天不间断同步，最新一条会置顶在实时快讯流顶部，打开首页就能看到当前这一批新料。",
  },
  {
    q: "「最快黑料」会先发后核吗？",
    a: "会先发，但一定带可信度标签。归属待证的会明确标注，完成交叉核实后我们回到原条更新状态，而不是另开一条新料。",
  },
  {
    q: "怎么判断一条黑料靠不靠谱？",
    a: "看来源与可信度标签即可：站内编辑部、网友整理、匿名投稿三档来源分开写清楚，每条还会给出可核验的线索描述。",
  },
  {
    q: "会不会收录无中生有的爆料？",
    a: "无材料支撑的投稿只会进入待证池，并明确标注「待证」，不与其他已核内容混排，避免把猜测当成结论。",
  },
  {
    q: "想追某个话题的最新进展怎么办？",
    a: "直接看热榜与专题目录，同一事件的后续会归到同一条时间线里，越靠上的通常是最近更新的那一版。",
  },
];